<template>
  <li class="nav-item dropdown theme-switcher" :class="{ show }" v-clickaway>
    <a
      href="#"
      class="navbar-nav-link dropdown-toggle"
      @click.prevent="openPopup"
      :title="currentLabel"
      aria-label="Темы"
    >
      Темы
    </a>

    <div class="dropdown-menu dropdown-menu-right theme-switcher__menu" :class="{ show }">
      <button
        v-for="option in options"
        :key="option.id"
        type="button"
        class="dropdown-item theme-switcher__item"
        :class="{ active: theme === option.id }"
        @click.prevent="select(option.id)"
      >
        <span class="theme-switcher__name">{{ option.label }}</span>
        <i v-if="theme === option.id" class="icon icon-check theme-switcher__check"></i>
      </button>
    </div>
  </li>
</template>

<script>
import { clickaway } from "@/mixins";
import { THEME_OPTIONS, applyTheme, getStoredTheme } from "@/core/theme";

export default {
  name: "ThemeSwitcher",
  mixins: [clickaway],

  data() {
    return {
      theme: getStoredTheme(),
      options: THEME_OPTIONS,
    };
  },

  computed: {
    currentLabel() {
      return THEME_OPTIONS.find((o) => o.id === this.theme)?.label || "Темы";
    },
  },

  methods: {
    select(id) {
      this.theme = id;
      applyTheme(id);
      this.show = false;
    },
  },
};
</script>

<style scoped>
.theme-switcher__menu {
  min-width: 9rem;
  padding: 0.25rem 0;
}

.theme-switcher__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  border: 0;
  background: transparent;
  text-align: left;
  padding: 0.45rem 1rem;
  cursor: pointer;
}

.theme-switcher__item:hover,
.theme-switcher__item.active {
  background: var(--dv-surface-muted);
}

.theme-switcher__name {
  font-size: 0.875rem;
  color: var(--dv-text);
}

.theme-switcher__check {
  color: var(--dv-primary);
  font-size: 0.95rem;
}
</style>
